export default "__VITE_ASSET__C_08EMZ0__"